import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import Logo from "../assets/images/logo.png";
import Background from "../assets/images/background1.png";


const LoginLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex">
      <div
        className="hidden md:flex w-[50vw] flex-col bg-[#143A78] items-center justify-center cursor-pointer bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${Background})`,
          backgroundSize: "130% 130%",
          backgroundPosition: "right bottom",
        }}
      >
        <img alt="bharat_logo" src={Logo} className="h-[20vh] w-auto" />
        <div className="text-md text-white font-poppins text-center font-medium mx-5">
          <h1 className="font-semibold text-md">SUPREME AUDIT INSTITUTION OF INDIA
            <br />
            लोकहितार्थ सत्यनिष्ठा
            <br />
            Dedicated to Truth in Public Interest
          </h1>
        </div>
      </div>
      <main className="w-full md:w-[50vw] flex-grow bg-gray-100">{children}</main>
    </div>
  );

};

export default LoginLayout;
